"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var React = require("react");
var react_redux_1 = require("react-redux");
var mapStateToProps = function (state) { return (__assign({}, state.layout)); };
var mapDispatchToPops = function (dispatch) { return ({
    onClicked: function () { return dispatch(LayoutAction_1.default.onPureWhatsAppClicked()); }
}); };
var WhatsAppUsButton = function (props) {
    return (React.createElement("a", { onClick: props.onClicked, className: 'c-calloremail__item c-calloremail__item--wa', target: "_blank", title: props.label },
        React.createElement("span", { className: "o-btn-whatsapp-icon" }),
        props.label));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToPops)(WhatsAppUsButton);
